import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { Avatar } from '@gem/call/Removable/components/Avatar/Avatar';
import { IcClose24Icon, IcDoneIcon } from '@gem/icons';
import { AvatarTypes, IconButton, IconViewSizes } from '@gem/ui-kit';

import { usePermissionRequestItemPresenter } from './PermissionRequestItem.presenter';
import styles from './PermissionRequestItem.styles.m.css';
import { IPermissionRequestItemProps } from './PermissionRequestItem.types';

export const PermissionRequestItem: FC<IPermissionRequestItemProps> = observer((props) => {
  const presenter = usePermissionRequestItemPresenter(props);

  return (
    <div className={styles.container}>
      <div className={styles.nameBlock}>
        <Avatar
          className={styles.avatar}
          title={presenter.member?.displayName || ''}
          url={presenter.member?.avatarUrl}
          backgroundColorIndex={presenter.member?.avatarColorIndex}
          type={AvatarTypes.Round_10}
        />
        <div className={styles.title}>{presenter.member?.displayName || ''}</div>
      </div>
      <div className={styles.buttons}>
        <IconButton
          Icon={IcClose24Icon}
          className={styles.menuButton}
          size={IconViewSizes.Small}
          iconSize={IconViewSizes.Medium}
          theme="11"
          onClick={presenter.reject}
        />
        <IconButton
          Icon={IcDoneIcon}
          size={IconViewSizes.Small}
          iconSize={IconViewSizes.Medium}
          theme="11"
          onClick={presenter.approve}
          className={styles.menuButton}
        />
      </div>
    </div>
  );
});
